<template>
    <div class="flex align-cen total">
        <img src="../../assets/images/rts_Logo.png" alt="" v-if="type ==1">
        <!-- <div v-if="type !=1">{{title}}</div> -->
        <div class="mft">
                <el-dropdown>
                <span class="el-dropdown-link flex align-cen" :style="type !=1 ? 'color:#000' : 'color:#fff'">
                 <img src="../../assets/images/head.png" alt="" class="sider-logo">
                 {{userinfo.username}} <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" v-if="type !=1">
                    <el-dropdown-item ><i class="icon-al-unlock-fill"></i> 修改密码</el-dropdown-item>
                    <el-dropdown-item   @click.native="logout1"><i class="icon-al-poweroff"></i>退出登录</el-dropdown-item>
                </el-dropdown-menu>
                <el-dropdown-menu slot="dropdown" v-else @click.native="close">
                    <el-dropdown-item ><i class="icon-al-unlock-fill" ></i> 关闭</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
        </div>
    </div>
</template>
<script>
import { logout } from "@/api/auth/login" 
    export default {
        name:'index',
        props: {
            type: [String, Number], //接口返回的点名
        },
        data() {
            return {
                userinfo:{},
                title:''
            }
        },
        computed: {
        },
        created() {
            // 获取本地存储用户信息
            this.userinfo = this.$locaStorage.setAge().get('userinfo')
        //     this.$bus.$on("titname", msg =>{   //vaPage传的时候的key是什么接收就必须是什么
        //      this.title = msg
        //    })
             
        },
        mounted() {},
        watch: {},
        methods: {
            close(){
                window.close()
            },
           logout1(){
                logout({})
                .then(res => {
                if(res.code == 0){
                localStorage.removeItem('token')
                localStorage.removeItem('userinfo')
                this.$router.push('login')
            }else{
                 this.$message.error(res.msg); 
            }
            })
            .catch(err => {
            })
            },
        },
        components: { 

         },
         
        destroyed(){
            // this.$bus.$off('titname')
        }
    }
</script>

<style scoped lang="scss">
    .total{
        width: 100%;
        img{
            width: 30px;
            margin-right: 10px;
        }
        .el-dropdown-link{
            color: #000;
            font-size: 16px;
            cursor: pointer;
        }
    }
</style>
